import createSetter from "./createSetter";

export default function compNeuroSlice(set) {
  return {
    setCompNeuroBrainCoverage: createSetter(set, "compNeuroBrainCoverage"),
    setNeuronalAccuracy: createSetter(set, "neuronalAccuracy"),
    setSimulationSpeed: createSetter(set, "simulationSpeed"),
    setSpeedFactor: createSetter(set, "speedFactor"),
    setModulatoryFactors: createSetter(set, "modulatoryFactors"),
  };
}
